import { dialogHeadding } from './Dialog.styles';
import { HeaderFactory } from '../../typography';
import { Styles } from '../../styles';
import { classes } from 'typestyle';

export const DialogHeadding = HeaderFactory('h1', classes(Styles.size.h4, dialogHeadding));
